// Components
import DatePicker from "vue2-datepicker"

// Constants
import { STATUS_CODES } from "@/app/constants/status-constants"
import { SUBSCRIPTION_STATUS } from "@/app/constants/subscription-constants";

// Mixins
import { tableMixins } from "@/app/mixins/utils/table-mixins"
import { dateMixins } from "@/app/mixins/utils/date-mixins"
import { shoppingMixins } from "@/app/mixins/components/shopping-mixins"
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins"
import { userMixins } from "@/app/mixins/modules/user-mixins"
import { switchPetMixins } from "@/app/mixins/modules/switch-pet-mixins"

// Services
import TransactionService from "@/app/services/main/transaction/transaction-service"

export default {
	name: "SubscriptionListingContainer",
	components: {
		DatePicker,
	},
	mixins: [
		tableMixins,
		dateMixins,
		toastMessageMixins,
		userMixins,
		shoppingMixins,
		switchPetMixins,
	],
	data() {

		const frequencyList = [
            {
                id: "P1M",
                name: "Monthly",
            },
            {
                id: "P3M",
                name: "Quarterly",
            },
            {
                id: "P12M",
                name: "Yearly",
            },
        ];

        const statusList = [
            {
                id: "A",
                name: "Active",
            },
            {
                id: "I",
                name: "Inactive",
            },
            {
                id: "CANCELLED",
                name: "Cancelled",
            },
			{
                id: "FOR_CANCELLATION",
                name: "For Cancellation",
            },
			{
                id: "ENDED",
                name: "Ended",
            },
        ];
		
		return {
			isAPILoading: false,
			isLoadMoreLoading: false,
			selectedDateTime: null,
			desc: true,
			sortBy: "createdAt",
			// table
			theads: [
				{
					name: "Subscription Name",
					searchLabel: "f_subscriptionName",
                    sortLabel: "subscriptionName",
					hasSearch: true,
					isDesc: false,
					style: "width: 35%",
				},
				{
					name: "Date Subscribed",
                    searchLabel: "f_createdAt",
                    sortLabel: "createdAt",
					hasSubscribedDatePicker: true,
					isDesc: false,
					style: null,
				},
				{
					name: "Expiry Date",
                    searchLabel: "f_subscriptionExpiry",
                    sortLabel: "subscriptionExpiry",
					hasExpiryDatePicker: true,
					isDesc: false,
					style: null,
				},
				{ 
					name: "Payment Method", 
					hasPaymentMethodFilter: true,
					searchLabel: "f_paymentMethod", 
					isDesc: false, 
					style: "min-width: 200px" 
				},
				// {
				// 	name: "Frequency",
				// 	searchLabel: "f_paymentFrequencyCode",
                //     sortLabel: "paymentFrequencyCode",
				// 	isDesc: false,
				// 	style: "min-width: 200px",
				// 	hasStatusFilter: true,
				// 	optionList: frequencyList,
				// },
				{
					name: "Status",
					searchLabel: "f_status",
					sortLabel: "status",
					isDesc: false,
					style: "min-width: 180px",
					hasStatusFilter: true,
					optionList: statusList,
				},
				{ name: null, searchLabel: null, sortLabel: null, isDesc: false, style: "width: 225px" },
			],
			paymentMethods: [
				{
					value: "Store credit",
					name: "Store Credit",
				},
				{
					value: "Stripe",
					name: "Credit Card",
				},
			],
			selectedOrderStatus: "",
			orderList: [],
			selectedSubscribedDate: "",
            selectedSubscribedExpiry: "",
			selectedPaymentMethod: "",
		}
	},
	created() {
		this.getTableContent()
		this.setCartCount(this.getActivePet.id)
		this.setPendingOrderCount(this.getActivePet.id)
	},
	watch: {
		selectedOrderStatus() {
			this.getTableContent(this.page, this.limit, this.sortBy, this.desc, true)
		},
		selectedSubscribedDate() {
            this.getTableContent(true);
        },
        selectedSubscribedExpiry() {
            this.getTableContent(true);
        },
		selectedPaymentMethod() {
			this.getTableContent(this.page, this.limit, this.sortBy, this.desc, true)
		},
	},
	methods: {
		refreshActivePetData() {
			this.getTableContent()
			this.setCartCount(this.getActivePet.id)
			this.setPendingOrderCount(this.getActivePet.id)
		},
		getTableContent(
			page = this.page,
			limit = this.limit,
			sortBy = this.sortBy,
			desc = this.desc,
			fromFilter = false
		) {
			page = fromFilter ? 1 : this.page
			this.callTransactionHistoryAPI({ page, limit, sortBy, desc })
		},
		callTransactionHistoryAPI(queryParams) {
			this.isAPILoading = true
			queryParams["petId"] = this.getActivePet.id

			if (this.columnsFilter) {
                const { f_subscriptionName, f_owner, f_emailAddress, f_petName, f_paymentFrequencyCode, f_status } =
                    this.columnsFilter;

                if (f_subscriptionName) {
                    queryParams["f_subscriptionName"] = f_subscriptionName;
                }

                if (f_owner) {
                    queryParams["f_owner"] = f_owner;
                }

                if (f_emailAddress) {
                    queryParams["f_emailAddress"] = f_emailAddress;
                }

                if (f_petName) {
                    queryParams["f_petName"] = f_petName;
                }

                if (f_paymentFrequencyCode) {
                    queryParams["f_paymentFrequencyCode"] = f_paymentFrequencyCode;
                }

                if (f_status) {
                    queryParams["f_status"] = f_status;
                }

				if (this.selectedPaymentMethod) {
					queryParams["f_paymentMethod"] = this.selectedPaymentMethod;
				}
            }

            if (this.selectedSubscribedDate) {
                queryParams["f_createdAt"] = this.formatDate(this.selectedSubscribedDate, "yyyy-MM-dd HH:mm");
            }

            if (this.selectedSubscribedExpiry) {
                queryParams["f_subscriptionExpiry"] = this.formatDate(
                    this.selectedSubscribedExpiry,
                    "yyyy-MM-dd HH:mm"
                );
            }
			
			TransactionService.getCustomerSubscriptionList(queryParams)
				.then((res) => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.tableContent = {
							tableData: res.data.data,
							paginationData: res.data.pagination,
						}
					} else {
						this.showAPIErrorToast(this.toastMessages.transactions().ERROR_GET_CUSTOMER_ORDERS, res)
					}

					this.isAPILoading = false
				})
				.catch(() => {
					this.showGenericErrorToast()
					this.isAPILoading = false
				})
		},
		goToSubscriptionDetailsPage(subscriptionId) {
			this.$router.push(`/purchases/subscriptions/${subscriptionId}/view`)
		},
		getClassByStatus(status) {
			switch (status) {
				case "FOR_CANCELLATION":
					return "text-warning"

				case "CANCELLED":
				case "ENDED":
					return "text-danger"

				case SUBSCRIPTION_STATUS.INACTIVE:
				case "I":
					return "text-secondary"
					
				default:
					return "text-primary"
			}
		},

		formatPaymentMethod(paymentMethod){
			if(!paymentMethod) return "";

			if(paymentMethod.toLowerCase() === "stripe"){
				return "Credit Card";
			}

			return paymentMethod;
		}
	},
}
